"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7526],{

/***/ 54027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5779);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



const MiniNav = (param)=>{
    let { className , navItems , stage , disabled , setStage  } = param;
    const selectedIndex = navItems.findIndex((items)=>{
        return items.targetStage === (stage === null || stage === void 0 ? void 0 : stage.stage);
    });
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
    const isLight = theme.type === "LIGHT";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center my-6 py-2 pb-6 cursor-pointer ".concat(navItems.length < 2 ? "justify-center" : "", " ").concat(className !== null && className !== void 0 ? className : "sm:pl-[35%] sm:pr-[35%] mt-20"),
        children: navItems.filter((i)=>{
            return !!stage && (stage === null || stage === void 0 ? void 0 : stage.skipPreview) && i.label === "Preview" ? false : true;
        }).map((item, index, items)=>{
            const isHighlighted = index <= selectedIndex;
            const isActive = index === selectedIndex;
            const { label , targetStage  } = item;
            const offTextColor = isLight ? "text-black" : "text-white";
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center",
                        onClick: ()=>{
                            if (!disabled && !isActive) {
                                setStage({
                                    stage: targetStage
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "\n                  w-9 h-9 rounded-full flex items-center justify-center text-xs\n                  ".concat(isHighlighted ? "bg-forumm-blue-light text-black" : "border border-forumm-gray " + offTextColor, "\n                  ").concat(isActive ? "outer-circle" : "", "\n                "),
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "absolute text-xs mt-11 text-center",
                                children: isActive ? label : label.split(" ").map((name, i)=>i > 0 ? name.slice(0, 1) : name).join(" .")
                            })
                        ]
                    }),
                    index < items.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 ".concat(index < selectedIndex ? "bg-forumm-blue-light" : "bg-forumm-gray", " h-px")
                    })
                ]
            }, "mininav-item-".concat(item.label));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MiniNav);


/***/ }),

/***/ 26291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47906);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39618);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var voca__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81209);
/* harmony import */ var _ColorPicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14857);
/* harmony import */ var _DateTimeInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8194);
/* harmony import */ var _DropdownInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61993);
/* harmony import */ var _FileInput__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40296);
/* harmony import */ var _PriceInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84456);
/* harmony import */ var _TextAreaInput__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33923);













const formElements = {
    FileInput: _FileInput__WEBPACK_IMPORTED_MODULE_10__/* .FileInput */ .S,
    DateTimeInput: _DateTimeInput__WEBPACK_IMPORTED_MODULE_8__/* .DateTimeInput */ .Y,
    TextInput: _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o,
    PriceInput: _PriceInput__WEBPACK_IMPORTED_MODULE_11__/* .PriceInput */ .t,
    TextAreaInput: _TextAreaInput__WEBPACK_IMPORTED_MODULE_12__/* .TextAreaInput */ .F,
    DropdownInput: _DropdownInput__WEBPACK_IMPORTED_MODULE_9__/* .DropdownInput */ .f,
    ColorPicker: _ColorPicker__WEBPACK_IMPORTED_MODULE_7__/* .ColorPicker */ .z
};
const INPUT_ELEMENTS = [
    "CheckboxInput",
    "DropdownInput"
];
const isProtectedInput = (element)=>{
    var ref, ref1;
    // if ((element.type as any).name === 'CheckboxInput') console.log({ element })
    if ((ref = element.props) === null || ref === void 0 ? void 0 : ref.isProtected) return true;
    if ((ref1 = element.type) === null || ref1 === void 0 ? void 0 : ref1.name) {
        return INPUT_ELEMENTS.includes(element.type.name);
    }
};
const getFormData = function(children, formData, setFormData) {
    let initialFormData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    children.forEach((element, i)=>{
        var ref;
        if ((element === null || element === void 0 ? void 0 : (ref = element.props) === null || ref === void 0 ? void 0 : ref.children) && !isProtectedInput(element)) {
            const { children: childElements  } = element.props;
            if (childElements) {
                const newChildren = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isArray)(childElements) ? [
                    ...childElements
                ] : [
                    childElements
                ];
                initialFormData = {
                    ...initialFormData,
                    ...getFormData(newChildren, formData, setFormData, initialFormData)
                };
                children[i] = children[i].type == _components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ...element.props,
                    children: newChildren
                }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    ...element.props,
                    children: newChildren
                }, i);
            }
        } else {
            var ref1;
            if (!(element === null || element === void 0 ? void 0 : (ref1 = element.props) === null || ref1 === void 0 ? void 0 : ref1.label)) return;
            const { label , required , onChange: existingOnChange  } = element.props;
            const camelCaseLabel = voca__WEBPACK_IMPORTED_MODULE_6__/* ["default"].camelCase */ .Z.camelCase(label);
            // console.log({ camelCaseLabel })
            if (camelCaseLabel == null || camelCaseLabel === "") {
                children[i] = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.cloneElement)(element, {
                    ...element.props,
                    key: i
                });
            } else {
                var ref2;
                children[i] = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.cloneElement)(element, {
                    ...element.props,
                    key: i,
                    value: formData.hasOwnProperty(camelCaseLabel !== null && camelCaseLabel !== void 0 ? camelCaseLabel : "") ? (ref2 = formData[camelCaseLabel !== null && camelCaseLabel !== void 0 ? camelCaseLabel : ""]) === null || ref2 === void 0 ? void 0 : ref2.value : undefined,
                    onChange: (value, invalidData)=>{
                        const isInvalid = [
                            required && value === undefined,
                            invalidData
                        ].some((val)=>val === true);
                        // console.log({ isInvalid })
                        setFormData((currentFormData)=>({
                                ...currentFormData,
                                [camelCaseLabel]: {
                                    value: value,
                                    invalid: isInvalid
                                }
                            }));
                        existingOnChange && existingOnChange(value, invalidData);
                    }
                });
                initialFormData = {
                    ...initialFormData,
                    [camelCaseLabel]: {
                        value: undefined,
                        invalid: required === true
                    }
                };
            }
        }
    });
    return initialFormData;
};
/**
 * Primary UI component for Forms
 */ const Form = (param)=>{
    let { className , children , onSubmit , initialFormData , error , clearFormOnSubmit =false , clearFormOnError =false , clearForm , show =true , ...rest } = param;
    let modifiedChildren = [
        ...children
    ];
    const getInitialFormData = ()=>{
        if (initialFormData) {
            const normalizedFormData = Object.keys(initialFormData).reduce((acc, key)=>{
                acc[key] = {
                    value: initialFormData[key],
                    invalid: false
                };
                return acc;
            }, {});
            getFormData(modifiedChildren, normalizedFormData, ()=>{});
            return normalizedFormData;
        } else {
            return getFormData(modifiedChildren, {}, ()=>{});
        }
    };
    const [formData, setFormData] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(getInitialFormData());
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        if (!!clearForm) setFormData(getInitialFormData());
    }, [
        clearForm
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        setFormData(getInitialFormData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        setErrorMessage(error || "");
    }, [
        error
    ]);
    getFormData(modifiedChildren, formData, setFormData);
    const [errorMessage, setErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const invalidForm = Object.values(formData).some((element)=>element.invalid);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        ...rest,
        className: className !== null && className !== void 0 ? className : "",
        onSubmit: async (e)=>{
            e.preventDefault();
            // console.log({ fd: Object.values(formData) })
            if (invalidForm) {
                setErrorMessage("One or more fields are invalid or missing");
                if (clearFormOnError) {
                    setFormData(getInitialFormData());
                }
                return;
            }
            if (onSubmit) {
                const formDataValues = Object.entries(formData).reduce((acc, param)=>{
                    let [key, value] = param;
                    return {
                        ...acc,
                        [voca__WEBPACK_IMPORTED_MODULE_6__/* ["default"].camelCase */ .Z.camelCase(key)]: value.value
                    };
                }, {});
                const errorMessage = await onSubmit(formDataValues);
                if (errorMessage) {
                    setErrorMessage(errorMessage);
                }
            }
            if (clearFormOnSubmit) {
                setFormData(getInitialFormData());
            }
        },
        children: [
            modifiedChildren,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                show: !!errorMessage || !!invalidForm,
                ignoreTheme: true,
                className: "flex justify-center items-center text-center transition-all ".concat(errorMessage || invalidForm ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold mb-6 sm:mt-0 md:mt-8"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "One or more fields are invalid"
            })
        ]
    });
};


/***/ }),

/***/ 33923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ TextAreaInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5779);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);





/**
 * Primary UI component for text input
 */ const TextAreaInput = (param)=>{
    let { label , placeholder , value ="" , onChange , onKeyDown , className , rows , hint , validations , required , testid , show =true , labelBgColour , preventBorder =false , dynamicResize =false , preventResize =false , setError  } = param;
    const parsedValidations = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultValidations */ .C)(undefined, validations);
    let errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(value, parsedValidations);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        onLoad();
    }, []);
    const onLoad = ()=>{
        if (!show) return;
        handleDynamicResize();
    };
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (value === null) value = "";
    function handleDynamicResize(e) {
        if (dynamicResize && ref.current) {
            ref.current.style.height = "auto";
            ref.current.style.height = ref.current.scrollHeight + "px";
        }
    }
    function handleKeyDown(e) {
        onKeyDown && onKeyDown(e);
        if (e.isDefaultPrevented() && ref.current) ref.current.style.height = "auto";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: [
            "flex flex-col",
            className
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute text-sm -translate-y-1/2 mb-2 ml-2 ".concat(required ? "pl-2" : "px-2", " transition-all ").concat(errorMessage ? "text-red-500" : ""),
                style: {
                    backgroundColor: labelBgColour ? labelBgColour : theme.backgroundColour
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: required ? "after:content-['*'] after:mx-2 after:text-red-500" : "",
                    children: label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                required: required,
                value: value,
                onChange: (e)=>{
                    errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(e.target.value, parsedValidations);
                    // setErrorMessage(errorMsg ?? '')
                    const isInvalid = errorMessage !== "";
                    var ref;
                    if (!!setError) setError(errorMessage, (ref = testid !== null && testid !== void 0 ? testid : label) !== null && ref !== void 0 ? ref : "unknown");
                    onChange && onChange(e.target.value, isInvalid);
                    handleDynamicResize(e);
                },
                rows: rows !== null && rows !== void 0 ? rows : 3,
                autoComplete: "on",
                placeholder: placeholder,
                className: "transition-all bg-transparent ".concat(preventBorder ? "" : "border", " ").concat(errorMessage ? "text-red-500 border-red-500" : "", " ").concat(preventResize ? "resize-none" : "", " rounded px-4 py-4 text-sm outline-none"),
                "data-testid": testid !== null && testid !== void 0 ? testid : null,
                onKeyDown: handleKeyDown,
                ref: ref
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 ml-2 text-xs",
                children: hint
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            })
        ]
    });
};


/***/ }),

/***/ 67526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_CreateEventLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/base/Text.tsx
var Text = __webpack_require__(40517);
// EXTERNAL MODULE: ./components/base/Modal.tsx
var Modal = __webpack_require__(18860);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/base/LoadingSpinner.tsx + 1 modules
var LoadingSpinner = __webpack_require__(38999);
// EXTERNAL MODULE: ./components/base/MiniNav.tsx
var MiniNav = __webpack_require__(54027);
// EXTERNAL MODULE: ./layouts/Wrapper.tsx + 10 modules
var Wrapper = __webpack_require__(41702);
// EXTERNAL MODULE: ./components/page/FooterUnauthenticated.tsx + 2 modules
var FooterUnauthenticated = __webpack_require__(79633);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/images/forummIcon.svg
var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgForummIcon = function SvgForummIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 43,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "url(#forummIcon_svg__a)",
    d: "M.5 0h41.641v45.231H.5z"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "forummIcon_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#forummIcon_svg__b",
    transform: "scale(.01282 .01176)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "forummIcon_svg__b",
    width: 78,
    height: 85,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
/* harmony default export */ var forummIcon = (SvgForummIcon);
;// CONCATENATED MODULE: ./public/images/BlackBaudIcon.svg
var _g, BlackBaudIcon_defs;
function BlackBaudIcon_extends() { BlackBaudIcon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return BlackBaudIcon_extends.apply(this, arguments); }

var SvgBlackBaudIcon = function SvgBlackBaudIcon(props) {
  return /*#__PURE__*/react.createElement("svg", BlackBaudIcon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#BlackBaudIcon_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M54.932 2.059c.305.174.558.428.73.735.177.324.267.689.262 1.058.005.37-.085.734-.262 1.058-.172.307-.425.56-.73.735a2.24 2.24 0 0 1-2.117 0 1.921 1.921 0 0 1-.734-.735 2.112 2.112 0 0 1-.28-1.058c-.006-.37.086-.735.266-1.058.173-.308.427-.562.735-.735a2.24 2.24 0 0 1 2.117 0h.013Zm.16 3.041a1.71 1.71 0 0 0 .473-1.248 1.722 1.722 0 0 0-.474-1.253 1.656 1.656 0 0 0-1.23-.478 1.674 1.674 0 0 0-1.24.474 1.699 1.699 0 0 0-.474 1.257 1.691 1.691 0 0 0 .474 1.253 1.66 1.66 0 0 0 1.24.478 1.642 1.642 0 0 0 1.23-.483Zm-.594-1.328a.65.65 0 0 1-.376.217l.597.855h-.39l-.553-.815h-.203v.806h-.328v-2.09h.589a.956.956 0 0 1 .61.168.567.567 0 0 1 .204.443.624.624 0 0 1-.128.39l-.022.026Zm-.925-.026h.243c.337 0 .505-.124.505-.368 0-.243-.168-.345-.505-.345h-.243v.713Z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "url(#BlackBaudIcon_svg__b)",
    d: "M.885 28.978a28.092 28.092 0 1 0 56.184 0 28.092 28.092 0 0 0-56.184 0Z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M40.118 32.493c0-1.594-1.86-4.387-1.86-4.387-.443-.665-.212-.886.478-.479l6.89 4.335c.69.443.69.611 0 1.036l-6.89 4.361c-.69.443-.885.186-.478-.478 1.86-2.794 1.86-4.388 1.86-4.388ZM25.28 42.026c6.101 0 9.9-4.397 9.896-9.497 0-5.287-3.706-9.74-9.989-9.502-1.77.071-3.325.917-4.511 1.718v-8.77h-3.649v20.724s2.148 5.313 8.249 5.313l.004.014Zm-4.604-6.163V29.22a6.549 6.549 0 0 1 4.188-2.568c4.224-.53 6.805 2.838 6.805 5.969a6.024 6.024 0 0 1-6.69 5.844 6.397 6.397 0 0 1-4.303-2.603Z"
  }))), BlackBaudIcon_defs || (BlackBaudIcon_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "BlackBaudIcon_svg__b",
    x1: 11.069,
    x2: 53.572,
    y1: 49.588,
    y2: 5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#0CD973"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#00CFFF"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "BlackBaudIcon_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v58H0z"
  })))));
};
/* harmony default export */ var BlackBaudIcon = (SvgBlackBaudIcon);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/getBlackBaudConstituentOptions.ts

const GET_BLACKBAUD_CONSTITUENT_OPTIONS = (0,_generated/* graphql */.B)("\n  query getBlackBaudConstituentOptions($email: String!) {\n    getConstituentOptions(email: $email) {\n      name\n      email\n      title\n      id\n      postalAddress\n      dietaryRequirements\n      summary_note\n    }\n  }\n");

;// CONCATENATED MODULE: ./components/event/ConstitutenPicker.tsx










const ConstituentPicker = (param)=>{
    let { show , setShow , name , email , onMatch , options , fullAttendee  } = param;
    const [remoteOptions, setRemoteOptions] = (0,react.useState)(options);
    const [hasConstitutentsToMatch, setHasConstitutentsToMatch] = (0,react.useState)(false);
    const metadata = typeof (fullAttendee === null || fullAttendee === void 0 ? void 0 : fullAttendee.metadata) === "object" && fullAttendee.metadata !== null && !Array.isArray(fullAttendee.metadata) ? fullAttendee.metadata : {};
    const { loading  } = (0,useQuery/* useQuery */.a)(GET_BLACKBAUD_CONSTITUENT_OPTIONS, {
        variables: {
            email
        },
        onError: (err)=>console.log({
                err
            }),
        onCompleted: (data)=>{
            setRemoteOptions((state)=>{
                const payload = [
                    ...state,
                    ...data.getConstituentOptions.filter((c)=>{
                        return !!(c === null || c === void 0 ? void 0 : c.email) && !!(c === null || c === void 0 ? void 0 : c.name) && !!(c === null || c === void 0 ? void 0 : c.id);
                    }).map((c)=>({
                            fullName: c.name,
                            email: c.email,
                            contact_id: c.id
                        }))
                ];
                // console.log({ payload })
                setHasConstitutentsToMatch(payload.length > 0);
                return payload;
            });
        }
    });
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
        className: "w-full flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
            size: "small"
        })
    });
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: show,
        setShow: setShow,
        title: name || "Forumm User",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: "font-base mb-4 mt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(forummIcon, {
                            className: "float-left mr-1",
                            viewBox: "0 0 43 46",
                            preserveAspectRatio: "xMidYMid meet",
                            height: "24px",
                            width: "24px"
                        }),
                        "This is your local Forumm attendee."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "table-auto w-full border-collapse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    className: "bg-gray-200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Full Name"
                                        }),
                                        Object.keys(metadata).map((key, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "px-4 py-2 text-left text-lg",
                                                children: key
                                            }, "".concat(key, "-").concat(index)))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    className: "h-20 border-b border-slate-200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "px-4 py-2 text-base",
                                            children: fullAttendee === null || fullAttendee === void 0 ? void 0 : fullAttendee.email
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "px-4 py-2 text-base",
                                            children: fullAttendee === null || fullAttendee === void 0 ? void 0 : fullAttendee.fullName
                                        }),
                                        Object.values(metadata).map((value, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-4 py-2 text-base",
                                                children: value
                                            }, idx))
                                    ]
                                })
                            })
                        ]
                    })
                }),
                hasConstitutentsToMatch && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: "font-base mb-4 mt-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackBaudIcon, {
                            className: "float-left mr-1",
                            viewBox: "0 0 58 58",
                            preserveAspectRatio: "xMidYMid meet",
                            height: "24px",
                            width: "24px"
                        }),
                        "Please match this participant to a Blackbaud constituent:"
                    ]
                }),
                hasConstitutentsToMatch ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "overflow-x-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "table-auto w-full border-collapse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    className: "bg-gray-200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Constituent"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Full Name"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Title"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Postal Address"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Dietary Requirements"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Participant Data"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "px-4 py-2 text-left text-lg",
                                            children: "Match to Participant"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: remoteOptions.map((option)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
                                        className: "h-20 border-b border-slate-200",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-4 py-2 text-base",
                                                children: (ref = option === null || option === void 0 ? void 0 : option.contact_id) !== null && ref !== void 0 ? ref : "-"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-4 py-2 text-base",
                                                children: option.email
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-4 py-2 text-base",
                                                children: option.fullName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-4 py-2 text-base",
                                                children: (ref1 = option === null || option === void 0 ? void 0 : option.title) !== null && ref1 !== void 0 ? ref1 : "-"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-4 py-2 text-base",
                                                children: (ref2 = option === null || option === void 0 ? void 0 : option.postalAddress) !== null && ref2 !== void 0 ? ref2 : "-"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-4 py-2 text-base",
                                                children: (ref3 = option === null || option === void 0 ? void 0 : option.dietaryRequirements) !== null && ref3 !== void 0 ? ref3 : "-"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-4 py-2 text-xs",
                                                children: option.summary_note ? (()=>{
                                                    try {
                                                        const parsedData = JSON.parse(option.summary_note);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-xs",
                                                            children: Object.entries(parsedData).map((param)=>/*#__PURE__*/ {
                                                                let [key, value] = param;
                                                                return (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                            children: [
                                                                                key,
                                                                                ":"
                                                                            ]
                                                                        }),
                                                                        " ",
                                                                        typeof value === "object" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                                                                            className: "whitespace-pre-wrap text-xs",
                                                                            children: JSON.stringify(value, null, 2)
                                                                        }) : String(value)
                                                                    ]
                                                                }, key);
                                                            })
                                                        });
                                                    } catch (error) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-red-500",
                                                            children: "-"
                                                        });
                                                    }
                                                })() : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-gray-500",
                                                    children: "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                className: "px-4 py-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    title: "Match",
                                                    type: "blackbaud",
                                                    size: "small",
                                                    onClick: ()=>onMatch({
                                                            email: option.email,
                                                            cId: option.contact_id
                                                        }, email)
                                                })
                                            })
                                        ]
                                    }, option.email);
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-center text-gray-500 mt-16 mb-10",
                    children: "There are no constituents that potentially match the email."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-end mt-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Save as new Constituents",
                        type: "blackbaud",
                        size: "small",
                        className: "ml-2",
                        onClick: ()=>onMatch({
                                email: "new"
                            }, email)
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ConstitutenPicker = (ConstituentPicker);

;// CONCATENATED MODULE: ./components/event/BlackBaudConstituents.tsx




const BlackBaudConstituents = (param)=>{
    let { localAttendees , remoteConstituents , isVisible , onSave , onBack  } = param;
    const [selectedConstituents, setSelectedConstituents] = (0,react.useState)({});
    const [approvedAttendees, setApprovedAttendees] = (0,react.useState)(new Set());
    const [blacklistAttendees, setBlacklistAttendees] = (0,react.useState)(new Set());
    const [visibleAttendees, setVisibleAttendees] = (0,react.useState)(localAttendees);
    // constitutent picker realted states
    const [showCp, setShowCp] = (0,react.useState)(false);
    const [cpAttendee, setCpAttendee] = (0,react.useState)();
    // Helper function to check partial name or email match
    const matchesConstituent = (attendee, constituent)=>{
        const [attendeeFirstName, attendeeLastName] = attendee.fullName.toLowerCase().split(" ");
        const [constituentFirstName, constituentLastName] = constituent.fullName.toLowerCase().split(" ");
        // Check if first name, last name or email matches
        const nameMatch = attendeeFirstName && constituent.fullName.toLowerCase().includes(attendeeFirstName) || attendeeLastName && constituent.fullName.toLowerCase().includes(attendeeLastName);
        const emailMatch = constituent.email.toLowerCase() === attendee.email.toLowerCase();
        return nameMatch || emailMatch;
    };
    // Filtered list of remote constituents based on partial matching
    const getMatchingConstituents = (attendee)=>{
        return remoteConstituents.filter((constituent)=>matchesConstituent(attendee, constituent));
    };
    const handleMatch = (selectedValue)=>{
        var ref;
        const attendeeEmail = (ref = cpAttendee === null || cpAttendee === void 0 ? void 0 : cpAttendee.email) !== null && ref !== void 0 ? ref : "";
        setShowCp(false);
        setSelectedConstituents({
            ...selectedConstituents,
            [attendeeEmail]: selectedValue
        });
    };
    const handleApprove = (attendeeEmail)=>{
        if (selectedConstituents[attendeeEmail]) {
            setApprovedAttendees((prevApprovedAttendees)=>{
                const updatedSet = new Set(prevApprovedAttendees);
                updatedSet.add(attendeeEmail);
                return updatedSet;
            });
        }
    };
    const handleReject = (attendeeEmail)=>{
        setVisibleAttendees(visibleAttendees.filter((attendee)=>attendee.email !== attendeeEmail));
    };
    const handleSave = ()=>{
        const curatedList = visibleAttendees.filter((attendee)=>approvedAttendees.has(attendee.email)) // Only return approved attendees
        .map((attendee)=>({
                localEmail: attendee.email,
                selectedEmail: selectedConstituents[attendee.email].email,
                cId: selectedConstituents[attendee.email].cId
            }));
        onSave(curatedList);
    };
    const hasKeys = (obj)=>obj && !Array.isArray(obj) && Object.keys(obj).length;
    if (!isVisible) return null;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    className: "table-auto w-full border-collapse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: "bg-gray-200",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "px-4 py-2 text-left text-lg",
                                        children: "Full Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "px-4 py-2 text-left text-lg",
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "px-4 py-2 text-left text-lg",
                                        children: "Participant Data"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "px-4 py-2 text-left text-lg min-w-[200px]",
                                        children: "Constituent"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "px-4 py-2 text-left text-lg",
                                        children: "Action"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: visibleAttendees.map((attendee)=>{
                                var ref, ref1, ref2;
                                let doNotSync = false;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    className: "h-20 border-b border-slate-200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "px-4 py-2 text-base",
                                            children: attendee.fullName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "px-4 py-2 text-base",
                                            children: attendee.email
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "px-4 py-2 text-xs",
                                            children: hasKeys(attendee === null || attendee === void 0 ? void 0 : attendee.metadata) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm",
                                                children: Object.entries(attendee.metadata).map((param)=>/*#__PURE__*/ {
                                                    let [key, value] = param;
                                                    return (0,jsx_runtime.jsxs)("div", {
                                                        className: "whitespace-pre-wrap text-xs",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                children: [
                                                                    key,
                                                                    ":"
                                                                ]
                                                            }),
                                                            " ",
                                                            value && typeof value === "object" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                                                                className: "whitespace-pre-wrap text-xs",
                                                                children: JSON.stringify(value, null, 2)
                                                            }) : String(value)
                                                        ]
                                                    }, key);
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-gray-500",
                                                children: "No Data"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "px-4 py-2 text-base",
                                            children: approvedAttendees.has(attendee.email) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "flex items-center",
                                                children: [
                                                    (ref = selectedConstituents[attendee.email]) === null || ref === void 0 ? void 0 : ref.email,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "flex items-center ml-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                            title: "Undo",
                                                            type: "secondary",
                                                            size: "small",
                                                            onClick: ()=>{
                                                                setApprovedAttendees((prevApprovedlist)=>{
                                                                    const updatedSet = new Set(prevApprovedlist);
                                                                    updatedSet.delete(attendee.email);
                                                                    setSelectedConstituents((state)=>{
                                                                        if (state[attendee.email]) {
                                                                            const data = Object.entries(state).filter((f)=>f[0] !== attendee.email);
                                                                            const payload = Object.fromEntries(data);
                                                                            console.log({
                                                                                payload
                                                                            });
                                                                            return {
                                                                                ...payload
                                                                            };
                                                                        }
                                                                        return state;
                                                                    });
                                                                    return updatedSet;
                                                                });
                                                            }
                                                        })
                                                    })
                                                ]
                                            }) : blacklistAttendees.has(attendee.email) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "flex items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    title: "Undo",
                                                    type: "secondary",
                                                    size: "small",
                                                    onClick: ()=>{
                                                        setBlacklistAttendees((prevBlacklist)=>{
                                                            const updatedSet = new Set(prevBlacklist);
                                                            updatedSet.delete(attendee.email);
                                                            return updatedSet;
                                                        });
                                                    }
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                        className: "mr-4",
                                                        title: (selectedConstituents === null || selectedConstituents === void 0 ? void 0 : (ref1 = selectedConstituents[attendee.email]) === null || ref1 === void 0 ? void 0 : ref1.email) ? "".concat(selectedConstituents === null || selectedConstituents === void 0 ? void 0 : (ref2 = selectedConstituents[attendee.email]) === null || ref2 === void 0 ? void 0 : ref2.email) : "Match",
                                                        type: "primary",
                                                        size: "small",
                                                        onClick: ()=>{
                                                            setShowCp(true);
                                                            setCpAttendee(attendee);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                        title: "Do not sync",
                                                        type: "secondary",
                                                        size: "small",
                                                        onClick: ()=>{
                                                            setBlacklistAttendees((prevBlacklist)=>{
                                                                const updatedSet = new Set(prevBlacklist);
                                                                updatedSet.add(attendee.email);
                                                                return updatedSet;
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "px-4 py-2",
                                            children: !approvedAttendees.has(attendee.email) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex space-x-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-black text-xs",
                                                    children: blacklistAttendees.has(attendee.email) ? "Won't Sync" : "Awaiting for selection"
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex space-x-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-green-600 text-xs",
                                                    children: (selectedConstituents === null || selectedConstituents === void 0 ? void 0 : selectedConstituents[attendee.email].email) === "new" ? "Will be synced to Participant" : "Will be saved as Constitutent"
                                                })
                                            })
                                        })
                                    ]
                                }, attendee.email);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-end mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Go Back",
                        type: "primary",
                        size: "small",
                        onClick: onBack
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Update",
                        type: "blackbaud",
                        size: "small",
                        onClick: handleSave,
                        className: "ml-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConstitutenPicker, {
                show: showCp,
                setShow: ()=>setShowCp(false),
                name: (ref = cpAttendee === null || cpAttendee === void 0 ? void 0 : cpAttendee.fullName) !== null && ref !== void 0 ? ref : "",
                email: (ref1 = cpAttendee === null || cpAttendee === void 0 ? void 0 : cpAttendee.email) !== null && ref1 !== void 0 ? ref1 : "",
                fullAttendee: cpAttendee,
                onMatch: (cntData, attendeeEmail)=>{
                    // console.log({ cntData })
                    handleMatch(cntData);
                    setTimeout(()=>{
                        setApprovedAttendees((prevApprovedAttendees)=>{
                            const updatedSet = new Set(prevApprovedAttendees);
                            updatedSet.add(attendeeEmail);
                            return updatedSet;
                        });
                    }, 0);
                },
                options: cpAttendee ? getMatchingConstituents(cpAttendee).filter((constituent)=>!Object.values(selectedConstituents).map((c)=>c.email).includes(constituent.email) || selectedConstituents[cpAttendee.email].email === constituent.email) : []
            })
        ]
    });
};
const parseAttendees = (attendeesString)=>{
    if (!attendeesString) return [];
    return attendeesString.split(",").map((attendee)=>{
        const [fullName, email] = attendee.trim().split(" (");
        return {
            fullName: fullName.trim(),
            email: (email === null || email === void 0 ? void 0 : email.replace(")", "").trim()) || ""
        };
    });
};
/* harmony default export */ var event_BlackBaudConstituents = (BlackBaudConstituents);

;// CONCATENATED MODULE: ./components/event/BlackBaudEventModal.tsx








const BlackBaudEventModal = (param)=>{
    let { data , show , onSave , setShow  } = param;
    var ref, ref1;
    const [checkedState, setCheckedState] = (0,react.useState)({});
    const [constituentsVisible, setConstituentsVisible] = (0,react.useState)(false);
    const [disabledState, setDisabledState] = (0,react.useState)({});
    const [error, setError] = (0,react.useState)();
    const [updatedConstituents, setUpdatedConstituents] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.local) {
            const initialCheckedState = {};
            const initialDisabledState = {};
            data.local.forEach((item)=>{
                const key = item.label.toLowerCase().replace(/\s+/g, "");
                initialDisabledState[key] = !item.content // Disable if content is falsy
                ;
                initialCheckedState[key] = !!item.content && !initialDisabledState[key] // Only check if content is present and it's not disabled
                ;
            });
            // Disable speaker sync
            initialDisabledState["speakers"] = true;
            initialCheckedState["speakers"] = false;
            // If it's the first-time sync, enforce "name" and "description" to be checked
            if (!data.remote) {
                if (initialDisabledState["name"]) {
                    initialCheckedState["name"] = true;
                    initialDisabledState["name"] = false;
                }
                if (initialDisabledState["description"]) {
                    initialCheckedState["description"] = true;
                    initialDisabledState["description"] = false;
                }
            }
            setCheckedState(initialCheckedState);
            setDisabledState(initialDisabledState);
        }
    }, [
        data
    ]);
    if (!(data === null || data === void 0 ? void 0 : data.local)) {
        return null;
    }
    const handleCheckboxChange = (label)=>{
        const key = label.toLowerCase().replace(/\s+/g, "");
        setCheckedState((prevState)=>({
                ...prevState,
                [key]: !prevState[key]
            }));
    };
    const handleConfirm = ()=>{
        setError(undefined);
        const isAnyOptionChecked = Object.values(checkedState).some((value)=>value === true);
        if (!isAnyOptionChecked) {
            setError("At least one option is required");
            return;
        }
        if (!data.remote && (!checkedState.title || !checkedState.description)) {
            setError("Please provide both a name and a description for the initial save");
            return;
        }
        const selection = Object.keys(checkedState).filter((key)=>checkedState[key]);
        onSave(selection, updatedConstituents);
        setTimeout(()=>{
            setUpdatedConstituents(undefined);
        }, 0);
    };
    const compareFields = (localContent, remoteContent)=>{
        if (!remoteContent || remoteContent === "" || remoteContent === "Not set") return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "text-yellow-600 text-sm",
            children: "Not Synced"
        });
        if (localContent === remoteContent) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-green-600 text-sm",
                children: "Synced"
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "text-yellow-600 text-sm",
            children: "Not Synced"
        });
    };
    const handleMarkAll = ()=>{
        const newCheckedState = {};
        Object.keys(checkedState).forEach((key)=>{
            if (!disabledState[key]) {
                newCheckedState[key] = true;
            } else {
                newCheckedState[key] = checkedState[key];
            }
        });
        setCheckedState(newCheckedState);
    };
    const handleSyncAttendees = ()=>{
        setConstituentsVisible(true);
    };
    // Extracting local and remote attendees from the data
    const localAttendeesString = ((ref = data.local.find((item)=>item.label === "Attendees")) === null || ref === void 0 ? void 0 : ref.content) || "";
    var ref2;
    const remoteAttendees = ((ref1 = ((ref2 = data === null || data === void 0 ? void 0 : data.remote) !== null && ref2 !== void 0 ? ref2 : []).find((item)=>item.label === "Attendees")) === null || ref1 === void 0 ? void 0 : ref1.list) || [];
    let localAttendees = parseAttendees(localAttendeesString);
    const remoteConstituents = remoteAttendees.map((cnt)=>({
            ...cnt,
            fullName: cnt.name
        }));
    try {
        const localAttendeesWithMetadata = localAttendees.map((attendee)=>{
            const attendeesEntry = data.local.find((entry)=>entry.label === "Attendees");
            // @ts-expect-error
            if (!attendeesEntry || !attendeesEntry.metadata) return attendee;
            // @ts-expect-error
            const matchingMetadata = attendeesEntry.metadata.find(// @ts-expect-error
            (meta)=>meta.email === attendee.email);
            if (!matchingMetadata) return attendee;
            const registrationFields = matchingMetadata.registrationFields || {};
            const firstKey = Object.keys(registrationFields)[0];
            if (!firstKey) return attendee;
            const metadataValue = registrationFields[firstKey];
            return {
                ...attendee,
                metadata: metadataValue
            };
        });
        localAttendees = localAttendeesWithMetadata;
    } catch (_e) {
        console.warn(_e);
    }
    const generateUpdateMessage = (updatedConstituents)=>{
        if (!updatedConstituents || updatedConstituents.length === 0) {
            return "";
        }
        const updates = updatedConstituents.map((constituent)=>{
            // console.log({ constituent })
            if (constituent.selectedEmail === "new") {
                return 'A new constituent will be created for "'.concat(constituent.localEmail, '".');
            }
            return "".concat(constituent.selectedEmail, ' will be updated with attendee "').concat(constituent.localEmail, '".');
        });
        const updateCount = updates.length;
        const message = "".concat(updateCount, " update").concat(updateCount > 1 ? "s" : "", " will be pushed:\n").concat(updates.join("\n"));
        return message;
    };
    const getAttendeeDiff = ()=>{
        if (updatedConstituents && updatedConstituents.length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-green-600 text-sm",
                children: "Synced"
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "text-yellow-600 text-sm",
            children: "Needs Review"
        });
    };
    const renderMultiline = (label)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: label.split(",").map((line, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: line.trim()
                }, index))
        });
    };
    const getBlackBaudDisplayText = (defaultText)=>{
        // console.log({ defaultText })
        if (updatedConstituents && updatedConstituents.length > 0) {
            const message = generateUpdateMessage(updatedConstituents);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-green-600 text-xs",
                children: message.split("\n").map((line, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: line
                    }, index))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "text-gray-600 text-xs",
            children: renderMultiline(defaultText)
        });
    };
    var _local;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: show,
        setShow: setShow,
        title: "Sync with Blackbaud Raiser's Edge NXT\xae",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(event_BlackBaudConstituents, {
                isVisible: constituentsVisible,
                onSave: (diffConstituents)=>{
                    setUpdatedConstituents(diffConstituents);
                    setConstituentsVisible(false);
                },
                onBack: ()=>setConstituentsVisible(false),
                localAttendees: localAttendees,
                remoteConstituents: remoteConstituents
            }),
            !constituentsVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "w-full relative p-2 min",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-3 gap-y-4 gap-x-0 overflow-y-auto max-h-[620px] scrollbar-custom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-gray-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "font-semibold mb-4 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forummIcon, {
                                                className: "float-left mr-1",
                                                viewBox: "0 0 43 46",
                                                preserveAspectRatio: "xMidYMid meet",
                                                height: "24px",
                                                width: "24px"
                                            }),
                                            "Forumm"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-gray-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "font-semibold mb-4 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackBaudIcon, {
                                                className: "float-left mr-1",
                                                viewBox: "0 0 58 58",
                                                preserveAspectRatio: "xMidYMid meet",
                                                height: "24px",
                                                width: "24px"
                                            }),
                                            "Blackbaud"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-gray-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-semibold mb-4 mt-4",
                                        children: "Sync"
                                    })
                                }),
                                ((_local = data.local) !== null && _local !== void 0 ? _local : []).map((localItem, index)=>{
                                    var ref;
                                    // if (localItem.label === 'Speakers') return
                                    const key = localItem.label.toLowerCase().replace(/\s+/g, "");
                                    const remoteItem = (ref = data.remote) === null || ref === void 0 ? void 0 : ref.find((remoteItem)=>remoteItem.label === localItem.label);
                                    const remoteContent = (remoteItem === null || remoteItem === void 0 ? void 0 : remoteItem.content) || "Not set";
                                    const bbDisplayText = [
                                        "Attendees",
                                        "Speakers"
                                    ].includes(localItem.label) ? getBlackBaudDisplayText(remoteContent) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-gray-600 text-xs",
                                        children: remoteContent
                                    });
                                    const localContet = localItem.content || "Not set";
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-start border-b border-b-slate-200",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: checkedState[key],
                                                        onChange: ()=>handleCheckboxChange(localItem.label),
                                                        className: "mr-4 mt-1 h-[15px] w-[15px] text-blue-600 focus:ring-blue-500 border-gray-300 rounded",
                                                        disabled: disabledState[key]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "font-medium text-gray-700",
                                                                children: localItem.label
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-gray-600 text-xs",
                                                                children: [
                                                                    "Attendees",
                                                                    "Speakers"
                                                                ].includes(localItem.label) ? renderMultiline(localContet) : localContet
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-start border-b border-b-slate-200",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            className: "font-medium text-gray-700 text-sm",
                                                            children: localItem.label
                                                        }),
                                                        bbDisplayText
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-start border-b border-b-slate-200",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: key === "attendees" ? getAttendeeDiff() : compareFields(localItem.content, remoteContent)
                                                    }),
                                                    key === "attendees" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                        className: "ml-4 -mt-1",
                                                        onClick: handleSyncAttendees,
                                                        title: "Review",
                                                        type: "blackbaud",
                                                        size: "small",
                                                        loading: false
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex flex-row w-full justify-end items-center",
                        children: [
                            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-600 font-semibold",
                                children: error
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        className: "ml-4",
                                        onClick: handleMarkAll,
                                        title: "Mark all",
                                        type: "primary",
                                        size: "small",
                                        loading: false
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        className: "ml-4",
                                        onClick: handleConfirm,
                                        title: "Sync",
                                        type: "blackbaud",
                                        size: "small",
                                        loading: false,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackBaudIcon, {
                                            viewBox: "0 0 58 58",
                                            preserveAspectRatio: "xMidYMid meet",
                                            height: "24px",
                                            width: "24px"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var event_BlackBaudEventModal = (BlackBaudEventModal);

// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./pages/create-event/space-creation.tsx + 1 modules
var space_creation = __webpack_require__(62114);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./libs/CreateEvent/CreateEventStage.ts
var CreateEventStage = __webpack_require__(98749);
// EXTERNAL MODULE: ./libs/CreateEvent/useEventEditor.tsx + 6 modules
var useEventEditor = __webpack_require__(25687);
;// CONCATENATED MODULE: ./layouts/CreateEventLayout.tsx















const CreateEventLayoutContent = (param)=>{
    let { children  } = param;
    const { blackBaudComparison , createEventStage , disableProgress , duplicateLoading , embedCode , embedCopied , eventActionsVisible , formData , handleConfirmPublish , handleCopyEmbedCode , handleDeleteEvent , handleDuplicateEvent , handleGoToStripeSettings , handlePublishRequest , handleSaveSelectionBlackBaud , items , loading , merchantLoading , profile , setCreateEventStage , setShowBlackBaudModal , setShowEmbedModal , setShowPublishConfirmation , setShowStripeRequiredModal , showBlackBaudModal , showEmbedModal , showPublishConfirmation , showStripeRequiredModal , stripeStatus  } = (0,useEventEditor/* useEventEditor */.O)();
    if ((createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === CreateEventStage/* CreateEventStage.Space */.M.Space) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* default */.ZP, {
            requireAuth: true,
            showFooter: false,
            requireChat: false,
            className: "h-screen",
            wrapperClasses: "flex flex-col flex-1 transition-all'",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "-mt-[80px] overflow-x-hidden h-[calc(100vh)] relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "flex justify-between items-center h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex flex-col items-center mx-auto",
                        style: {
                            width: "90%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                className: "text-2xl my-2 font-bold",
                                children: "Create an event Space"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex flex-row justify-evenly space-x-2 overflow-x-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(space_creation["default"], {})
                            })
                        ]
                    })
                })
            })
        });
    }
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* default */.ZP, {
        requireAuth: true,
        showFooter: false,
        requireChat: false,
        className: "h-screen",
        wrapperClasses: "flex flex-col flex-1 transition-all'",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "-mt-[80px] pt-[80px] overflow-x-hidden h-[calc(100vh)] relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "px-4 md:px-20 lg:px-[156px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "py-6 sm:py-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "text-2xl",
                                        children: [
                                            window.location.href.includes("?id=") ? "Edit" : "Create",
                                            " ",
                                            "Event for ",
                                            (ref = profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref !== void 0 ? ref : profile === null || profile === void 0 ? void 0 : profile.university
                                        ]
                                    }),
                                    eventActionsVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                className: "ml-auto mr-4 min-w-[130px]",
                                                onClick: ()=>setShowEmbedModal(true),
                                                title: "Get embed code",
                                                type: "secondary",
                                                size: "medium"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                onClick: handlePublishRequest,
                                                title: (formData === null || formData === void 0 ? void 0 : formData.isPublished) ? "Published" : "Publish Event",
                                                type: "success",
                                                size: "medium",
                                                disabled: (ref1 = formData === null || formData === void 0 ? void 0 : formData.isPublished) !== null && ref1 !== void 0 ? ref1 : false,
                                                className: "mr-4 min-w-[110px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                className: "min-w-[110px]",
                                                confirmationModal: {
                                                    title: "Confirm Event Duplication",
                                                    content: "Are you sure you want to duplicate this event?"
                                                },
                                                loading: duplicateLoading,
                                                onClick: handleDuplicateEvent,
                                                title: "Duplicate",
                                                type: "secondary",
                                                size: "medium",
                                                isInConfirmationModal: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                className: "ml-4 min-w-[110px]",
                                                confirmationModal: {
                                                    title: "Confirm Event Deletion",
                                                    content: "Are you sure you want to delete this event?"
                                                },
                                                onClick: handleDeleteEvent,
                                                title: "Delete",
                                                type: "danger",
                                                size: "medium",
                                                isInConfirmationModal: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniNav/* default */.Z, {
                                stage: createEventStage,
                                setStage: setCreateEventStage,
                                navItems: items,
                                disabled: disableProgress
                            }),
                            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex items-center justify-center w-full py-24",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                                    size: "medium"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: children
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toaster */.x7, {
                    toastOptions: {
                        className: "shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]",
                        duration: 4000
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(event_BlackBaudEventModal, {
                    show: showBlackBaudModal,
                    setShow: setShowBlackBaudModal,
                    data: blackBaudComparison,
                    onSave: handleSaveSelectionBlackBaud
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                    title: "Confirm Publish Event",
                    show: showPublishConfirmation,
                    setShow: setShowPublishConfirmation,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            children: "Are you sure you want to publish this event? This cannot be undone."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "flex w-full space-x-4 mt-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: ()=>setShowPublishConfirmation(false),
                                    className: "flex-1",
                                    title: "Cancel",
                                    type: "tertiary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: handleConfirmPublish,
                                    className: "flex-1",
                                    title: "Confirm",
                                    type: "danger"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                    title: "Stripe is required for paid tickets",
                    show: showStripeRequiredModal,
                    setShow: setShowStripeRequiredModal,
                    className: "max-w-2xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex flex-col gap-4 text-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                children: "This event includes paid tickets. Link and activate Stripe Connect in your organisation settings before publishing so attendees can pay securely."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "rounded-lg border border-forumm-menu-border p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "font-semibold",
                                        children: "Payment setup status"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "mt-2 opacity-80",
                                        children: merchantLoading ? "Checking Stripe status..." : stripeStatus.isReady ? "Stripe is ready." : "Stripe setup is incomplete."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex flex-col gap-3 sm:flex-row sm:justify-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        title: "Cancel",
                                        type: "tertiary",
                                        onClick: ()=>setShowStripeRequiredModal(false)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        title: "Open organisation settings",
                                        type: "primary",
                                        onClick: handleGoToStripeSettings
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                    title: "Event Embed Code",
                    show: showEmbedModal,
                    setShow: setShowEmbedModal,
                    className: "max-w-3xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex flex-col gap-4 py-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                className: "text-sm",
                                ignoreTheme: true,
                                children: "Add this HTML block wherever you want the registration form to appear."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                className: "min-h-[220px] w-full resize-none rounded border border-forumm-menu-border bg-transparent p-4 font-mono text-sm",
                                readOnly: true,
                                value: embedCode
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: handleCopyEmbedCode,
                                    title: embedCopied ? "Copied" : "Copy code",
                                    type: "primary",
                                    size: "medium",
                                    icon: embedCopied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineDone */.ddU, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineFileCopy */._qq, {})
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterUnauthenticated/* default */.Z, {
                    transparent: false
                })
            ]
        })
    });
};
const CreateEventLayout = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(useEventEditor/* EventEditorProvider */.N, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateEventLayoutContent, {
            children: children
        })
    });
};
/* harmony default export */ var layouts_CreateEventLayout = (CreateEventLayout);


/***/ }),

/***/ 62114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ space_creation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
// EXTERNAL MODULE: ./libs/CreateEvent/useEventEditor.tsx + 6 modules
var useEventEditor = __webpack_require__(25687);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/inputs/Form.tsx
var Form = __webpack_require__(26291);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/users/elevateAccount.ts

const ELEVATE_ACCOUNT = (0,_generated/* graphql */.B)("\n  mutation elevateAccount($orgName: String!) {\n    elevateAccount(orgName: $orgName) {\n      success\n      orgName\n      error\n    }\n  }\n");

// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
;// CONCATENATED MODULE: ./pages/create-event/space-creation.tsx










const SpaceCreationForm = ()=>{
    var ref;
    const { syncProfile  } = (0,useAuth/* useAuth */.aC)();
    const { errors , setErrors  } = (0,useEventEditor/* useEventEditor */.O)();
    const [elevateAccount, { loading  }] = (0,useMutation/* useMutation */.D)(ELEVATE_ACCOUNT);
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "w-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
                error: errors === null || errors === void 0 ? void 0 : (ref = errors[0]) === null || ref === void 0 ? void 0 : ref.message,
                onSubmit: async (data)=>{
                    const { nameYourEventSpace  } = data;
                    elevateAccount({
                        variables: {
                            orgName: nameYourEventSpace
                        },
                        onCompleted: (res)=>{
                            if (res.elevateAccount.error) {
                                return errorHandler("spaceNameSubmit")(res.elevateAccount.error, "Name your event Space");
                            }
                            if (res.elevateAccount.success) {
                                if (syncProfile) syncProfile();
                            }
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "mb-8",
                        children: [
                            "Looks like you don't have your own event Space yet. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " Not a problem, you can create one now."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                        label: "Name your event Space",
                        setError: errorHandler("spaceName"),
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        className: "ml-auto overflow-hidden",
                        buttonType: "submit",
                        title: "Create Space",
                        loading: loading
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var space_creation = (SpaceCreationForm);


/***/ })

}]);